module.exports = __webpack_public_path__ + "static/media/img_faceassessmenton_eye_to_brows.2dced2b7.jpg";